export default {
  danger: {
    title: 'Zone de danger',
    subtitle: "Actions sur l'organisation elle-même",
    deleteTitle: 'Supprimer cette organisation',
    deleteDescription:
      "{name} et tout son contenu seront supprimés : ses espaces et leurs contenus, ses rôles, ses invitations en attente et ses clés API. Ses chaînes sont mises hors ligne et les comptes de leurs abonnés supprimés. Le crédit restant est perdu, sans remboursement, et son renouvellement automatique s'arrête. Tous les membres perdent l'accès. Votre propre compte est conservé.",
    confirmLabel: 'Saisissez {name} pour confirmer',
    submit: "Supprimer l'organisation",
    deleted: '{name} a été supprimée.',
    alreadyDeleted: 'Cette organisation a déjà été supprimée.',
    failed: "L'organisation n'a pas pu être supprimée. Réessayez.",
    transferTitle: 'Transférer la propriété',
    transferDescription:
      'Confiez {name} à un autre membre : il prend votre rôle, et vous passez au rôle de votre choix.',
    transferMemberLabel: 'Membre qui reprend',
    transferStepDownLabel: 'Votre rôle ensuite',
    transferSubmit: "Transférer l'organisation",
    transferConfirmTitle: 'Transférer {name} ?',
    transferConfirmText: '{member} prend votre rôle, et vous devenez {role}. Le changement est immédiat.',
    transferConfirm: 'Transférer',
    transferred: '{name} a été transférée à {member}.',
    transferGone: "Ce membre ne fait plus partie de l'organisation.",
    transferFailed: "L'organisation n'a pas pu être transférée. Réessayez.",
    transferNoCandidate: "Il n'y a aucun autre membre à qui transférer l'organisation.",
  },
}
